<nav class="navbar navbar-expand-md">
  <!-- Reserves for show and hide of the side -->
  <!-- <button class="btn btn-primary d-none d-xs-inline d-md-none" id="menu-toggle" (click)="toggle($event)"><i class="fa fa-bars"></i></button> -->
  <button class="" type="button" data-toggle="collapse" id="mobile-btn" data-target="#mobile-menu-contents">
    <i class="fa fa-bars"></i>
  </button>
  <div class="navbar-collapse collapse" id="mobile-menu-contents">
    <div class="d-flex flex-column">
      <div class="my-2 flex-fill menu-top">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a
              [routerLink]="['/user/dashboard']"
              class="list-group-item list-group-item-action"
            >
              User Portfolio
            </a>
          </li>
          <li class="nav-item">
            <a
              [routerLink]="['/admin/dashboard']"
              class="list-group-item list-group-item-action"
            >
              Admin Dashboard
            </a>
          </li>
          <li class="nav-item">
            <a
              [routerLink]="['/admin/series']"
              class="list-group-item list-group-item-action"
            >
              Series & Modules
            </a>
          </li>
          <li class="nav-item">
            <a
              [routerLink]="['/admin/organisations']"
              class="list-group-item list-group-item-action"
            >
              Enterprises
            </a>
          </li>
          <li id="settings" class="nav-item ">
            <a
              [routerLink]="['/admin/users']"
              class="list-group-item list-group-item-action"
            >
              Users
            </a>
          </li>
          <li class="nav-item settings-options ">
            <a
              [routerLink]="['/admin/device-orders']"
              class="list-group-item list-group-item-action"
            >
              Device Orders
            </a>
          </li>
          <li class="nav-item settings-options ">
            <a
              [routerLink]="['/admin/billing-history']"
              class="list-group-item list-group-item-action"
            >
              Billing History
            </a>
          </li>
          <li class="nav-item settings-options ">
            <a
              [routerLink]="['/admin/challenge-report']"
              class="list-group-item list-group-item-action"
            >
              7-Day Challenge Results
            </a>
          </li>
          <li class="nav-item settings-options ">
            <a
              (click)="authService.logout()"
              class="list-group-item list-group-item-action"
            >
              Log Out
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</nav>
